import React, { ImgHTMLAttributes } from "react";
import { IMakeWesrvURL, makeWsrvURL } from "../../lib/Media/util";
import {
    LazyLoadImage,
    LazyLoadImageProps,
} from "react-lazy-load-image-component";

export interface IWsrvImageProps {
    urlParams: IMakeWesrvURL;
    imgProps?: Partial<LazyLoadImageProps>;
    stops?: number[];
    sizeBuffer?: number;
    widthMax?: number;
    className?: string;
    lazy?: boolean;
}

export const WsrvImage: React.FC<IWsrvImageProps> = ({
    urlParams,
    imgProps,
    stops = [400, 600, 800, 1000, 1200, 1600, 2000, 2400],
    sizeBuffer = 200,
    widthMax = 2400,
    lazy = true,
    className,
}) => {
    let srcSet: string[] = [];
    let sizes: string[] = [];
    let url = makeWsrvURL(urlParams);
    stops.map((w) => {
        w <= widthMax + sizeBuffer &&
            srcSet.push(
                makeWsrvURL({ ...urlParams, width: w }) + " " + w + "w"
            ) &&
            sizes.push("(max-width: " + (w - sizeBuffer) + "px) " + w + "px");
    });
    let fullProps: Omit<
        ImgHTMLAttributes<HTMLImageElement>,
        "placeholder" | "onload"
    > = {
        src: url,
        srcSet: srcSet.join(","),
        sizes: sizes.join(","),
        className: className,
        loading: "lazy",
        ...imgProps,
    };
    return lazy ? (
        <LazyLoadImage effect="opacity" {...fullProps} />
    ) : (
        <img {...fullProps} />
    );
};
